import React from 'react'

const News = () => {
  return (
    <div
      style={{
        height: '70vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '28px',
        textTransform: 'capitalize',
        fontWeight: 'bold',
      }}
    >
      News under construction
    </div>
  )
}

export default News
